module.exports = __webpack_public_path__ + "img/currency3.52bffe0a.png";